import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { DocumentsService } from "../../../../auth/service/documents.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";
import { IDocument, IDocumentCategory } from "app/auth/models/document-id";

@Component({
  selector: "app-documents-my-documents",
  templateUrl: "./documents-my-documents.component.html",
  styleUrls: ["./documents-my-documents.component.scss"],
})
export class DocumentsMyDocumentsComponent implements OnInit {
  private currentUser: ICurrentUser;
  public contentHeader: IContentHeader;
  private documents: IDocument[] = [];
  public documents_categories: IDocumentCategory[];
  public filter_keyword: string = "";
  public filter_category: string = "";
  public filter_status_signature: number = 4;
  public filter_status_acception: number = 4;
  public tableLimit: number = 10;
  public filtered_documents: IDocument[] = [];

  constructor(
    public _utilService: UtilsService,
    private _userService: UserService,
    public _authenticationService: AuthenticationService,
    public _documentService: DocumentsService,
  ) {}

  async ngOnInit() {
    this.currentUser = await this._authenticationService.getCurrentUser();
    await this.loadDocuments();
    this.documents_categories = await this._documentService.getCategoriesList();
    this.currentUser = await this._authenticationService.getCurrentUser();

    this.contentHeader = {
      headerTitle: italian.data.MENU.MY_DOCUMENTS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MY_DOCUMENTS,
            isLink: false,
          },
        ],
      },
    };
  }

  async loadDocuments() {
    this.documents = await this._documentService.getMyDocuments();

    this.documents.map((document: IDocument) => {
      document.title = document.document_data.title.replace(` - ${this.currentUser.firstname} ${this.currentUser.lastname}`, "");
      document.fileType = "pdf";
      if (document.document_data.description && document.document_data && document.document_data.description.includes("users/")) {
        document.fileType = document.document_data.description.split(".").pop();
      }
    });

    this.filterDocuments();
  }

  filterDocuments() {
    let outputItems: IDocument[] = this.documents;

    if (this.filter_status_signature < 4) {
      if (this.filter_status_signature == 3) {
        outputItems = outputItems.filter((item) => item.document_data.require_signature == 0);
      } else {
        outputItems = outputItems.filter((item) => item.document_user_data?.signed == this.filter_status_signature && item.document_data.require_signature === 1);
      }
    }
    if (this.filter_status_acception < 4) {
      if (this.filter_status_acception == 3) {
        outputItems = outputItems.filter((item) => item.document_data.require_acception == 0);
      } else {
        outputItems = outputItems.filter((item) => item.document_user_data?.having_read == this.filter_status_acception && item.document_data.require_acception === 1);
      }
    }
    if (this.filter_category.length > 0) {
      outputItems = outputItems.filter((item) => item.document_data.category.toLowerCase() === this.filter_category.toLowerCase());
    }

    if (this.filter_keyword.length > 0) {
      const keyword = this.filter_keyword.toLowerCase().trim();
      outputItems = outputItems.filter((item) => item.title.toLowerCase().includes(keyword) || item.send_date.includes(keyword));
    }

    this.filtered_documents = outputItems;
  }
}
